import {
  ALL_COMPLETE_GROUP_ORDERS_FAIL,
  ALL_COMPLETE_GROUP_ORDERS_REQUEST,
  ALL_COMPLETE_GROUP_ORDERS_SUCCESS,
  ALL_COMPLETE_RAW_ORDERS_FAIL,
  ALL_COMPLETE_RAW_ORDERS_REQUEST,
  ALL_COMPLETE_RAW_ORDERS_SUCCESS,
  ALL_PENDING_GROUP_ORDERS_FAIL,
  ALL_PENDING_GROUP_ORDERS_REQUEST,
  ALL_PENDING_GROUP_ORDERS_SUCCESS,
  ALL_PENDING_RAW_ORDERS_FAIL,
  ALL_PENDING_RAW_ORDERS_REQUEST,
  ALL_PENDING_RAW_ORDERS_SUCCESS,
} from "app/utils/constants/ordersConstant";
import {
  FETCH_ALL_LENGTH_DROPDOWN_FAIL,
  FETCH_ALL_LENGTH_DROPDOWN_REQUEST,
  FETCH_ALL_LENGTH_DROPDOWN_SUCCESS,
  FETCH_ALL_THICKNESS_DROPDOWN_FAIL,
  FETCH_ALL_THICKNESS_DROPDOWN_REQUEST,
  FETCH_ALL_THICKNESS_DROPDOWN_SUCCESS,
  FETCH_ALL_WIDTH_DROPDOWN_FAIL,
  FETCH_ALL_WIDTH_DROPDOWN_REQUEST,
  FETCH_ALL_WIDTH_DROPDOWN_SUCCESS,
} from "../../utils/constants/masterConstants";

const INIT_STATE = {
  loading: false,
  error: null,
  length: [],
  width: [],
  thickness: [],
};

export const sizeDropdownReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    //length
    case FETCH_ALL_LENGTH_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_LENGTH_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        length: action.payload.data,
      };

    case FETCH_ALL_LENGTH_DROPDOWN_FAIL:
      return {
        loading: false,
        length: [],
        error: action.payload,
      };

    //width
    case FETCH_ALL_WIDTH_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_WIDTH_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        width: action.payload.data,
      };

    case FETCH_ALL_WIDTH_DROPDOWN_FAIL:
      return {
        loading: false,
        width: [],
        error: action.payload,
      };

      
    //thickness
     case FETCH_ALL_THICKNESS_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ALL_THICKNESS_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        thickness: action.payload.data,
      };

    case FETCH_ALL_THICKNESS_DROPDOWN_FAIL:
      return {
        loading: false,
        thickness: [],
        error: action.payload,
      };
      
    default:
      return state;
  }
};
